import LoginPage from '../../src/components/Auth/LoginPage';
export default LoginPage;